import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Endfooter from "../Homecomponents/Endfooter";
import { initializeUserData } from "../utils/userCartWishlistUtils";
import Superheader from "../KalHome/Superheader";

const Login = () => {
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    try {
      // Get user data from the API
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
      );

      // Check if the email and password match any user in the database
      const matchedUser = response.data.find(
        (item) =>
          item.email === formData.email && item.password === formData.password
      );

      if (matchedUser) {
        // Successful login, store user data in session storage
        setSuccess("Login successful!");
        sessionStorage.setItem("user", JSON.stringify(matchedUser));

        initializeUserData(matchedUser);

        // Redirect to homepage (shop page)
        setFormData({
          email: "",
          password: "",
        });
        navigate("/"); // Redirect to the homepage (shop)
      } else {
        // Invalid credentials
        setError("Invalid credentials. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Error occurred while processing your request.");
    }
  };

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>      <div className="login-wrapper">
        <div className="login-container">
          <div className="login-left">
            <div className="logo-container mb-2">
              <a href="/">
                <div className="logo-container">
                  <a href="/">
                    <div
                      className="mainlogotitle"
                      style={{ fontSize: "34px", fontFamily: "kalanjiyamfont", color:"white" }}
                    >
                      Kalanjiyam
                      <br></br>
                      <span
                        style={{
                          fontSize: "24px",
                          fontFamily: "botiquefont",
                          marginLeft: "100px",
                          color:"white"
                        }}
                      >
                        Boutique.
                      </span>
                    </div>
                  </a>
                </div>
              </a>
            </div>
            <p className="login-powered">
              Discover the latest fashion trends with us.
            </p>
            <p className="welcome-message">
              Welcome back, let’s get you shopping!
            </p>
          </div>

          <div className="login-right">
            <h2 className="hello">Login</h2>
            {success ? (
              <p className="success-message">{success}</p>
            ) : (
              <form className="login-form" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-control login-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="form-control login-input"
                  />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button className="btn login-submit" type="submit">
                  Login
                </button>
              </form>
            )}
            <div className="dont-have-account">
              <p>
                Don't have an account?{" "}
                <span>
                  <a href="/register" className="register-link">
                    Register here!
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Endfooter />
    </>
  );
};

export default Login;
